import { AbstractReport } from '../abstract-report.model';
import { AccessorsMutatorsDecorator } from '../../../../helpers/model';

export class UserReconciliation extends AbstractReport {

}

AccessorsMutatorsDecorator(
    'users',
    'groups',
)(UserReconciliation);



// WEBPACK FOOTER //
// ./src/pms-api/models/reports/daily-activity/user-reconciliation.model.js